import React, { ChangeEvent, ReactNode } from 'react';
import Loading from 'flow/components/ui-components/Loading';

interface Props {
    name: string;
    children?: ReactNode;
    onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    checked?: boolean;
    disabled?: boolean;
    showLoadingSpinner?: boolean;
}

const RadioButton = ({
    name,
    children,
    onChange,
    checked,
    disabled,
    showLoadingSpinner,
}: Props) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event, event.target.checked);
    };

    return (
        <label className="flex flex-1 cursor-pointer items-center gap-x-3 px-2 py-1">
            <input
                name={name}
                type="radio"
                checked={checked}
                disabled={disabled}
                onChange={handleChange}
                // The forms plugin rings a focused radio in blue on every
                // focus; `focus-ring` shows the browser's ring instead.
                className="form-radio focus-ring m-1 size-6 border-2 border-gray-600 text-gray-600 focus:ring-0 focus:ring-offset-0 dark:bg-gray-500"
            />
            <span className="flex flex-1 flex-col text-gray-800">
                {children}
            </span>
            {showLoadingSpinner && (
                <div className="flex">
                    <Loading size={16} disableTimeout={true} />
                </div>
            )}
        </label>
    );
};

export default RadioButton;
